<template>
  <a-form-model :model="form" ref="formModel" @submit="handleSubmit" class="match-form">

    <div class="match-header">
      <a-form-model-item label="比赛名字" prop="matchName" :rules="{ required: true, message: '请选择比赛名字',trigger:'onchange' }"
                         :labelCol="{xs: {span: 4},sm: {span: 4}}"
                         class="comp-name-style"
      >
        <a-select v-model="form.matchId" placeholder="选择比赛名字" style="width: 100%;min-width: 500px"  >
          <a-select-option  v-for="match in specialMatchList" :key="match.match_id">{{ match.match_name+'-'+match.location+'-'+match["start_date"][0]+'-'+match["start_date"][1]+'-'+match["start_date"][2] }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="国家" prop="country" :rules="{ required: true, message: '请输入国家的英文名',trigger: 'onchange' }" :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 10 }">
        <a-input v-model="form.country" placeholder="输入国家的英文名" />
      </a-form-model-item>
      <a-form-model-item label="城市" prop="city" :rules="{ required: true, message: '请输入城市的英文名',trigger: 'onchange' }" :label-col="{ span: 4 }"
                         :wrapper-col="{ span: 10 }">
        <a-input v-model="form.city" placeholder="输入城市的英文名" />
      </a-form-model-item>
    </div>
    <div v-for="(subMatch, index) in form.subMatches" :key="index" :class="subMatch.isValid?'valid-sub-match':'sub-match'">
      <div class="sub-match-info">
        <div class="sub-match-row">
          <div class="sub-match-header">
            <a-button type="dashed" @click="removeSubMatch(index)">删除子比赛</a-button>
          </div>
          <a-form-model-item label="子赛事类别" prop="category" :rules="{ required: true, message: '请选择子赛事类别',trigger:'onchange' }" >
            <a-select v-model="subMatch.category" placeholder="选择子赛事类别">
              <a-select-option v-for="category in categories" :key="category">{{ category }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="比赛等级" prop="level" :rules="{ required: true, message: '请选择比赛等级',trigger:'onchange' }">
            <a-select v-model="subMatch.level" placeholder="选择比赛等级">
              <a-select-option v-for="level in levels" :key="level.key">{{ level.label }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="比赛日期" prop="date" :rules="{ required: true, message: '请选择比赛日期',trigger:'onchange' }">
            <a-date-picker v-model="subMatch.date" />
          </a-form-model-item>
          <a-form-model-item label="比赛场次(数字)" prop="subMatchIndex" :rules="{ required: true, message: '请填写场次',trigger:'onchange' }">
            <a-input v-model="subMatch.subMatchIndex" />
          </a-form-model-item>
          <a-form-model-item label="是否双打" prop="isDoubles" :rules="{ required: true, message: '请选择是否双打' }">
            <a-radio-group v-model="subMatch.isDoubles">
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </a-form-model-item>

        </div>
      </div>
      <div class="teams-info">
        <div v-for="(team, tIndex) in subMatch.teams" :key="tIndex" class="team-info">
          <div class="team-row">
            <a-form-model-item :label="`队伍${tIndex+1} 国家代码`" prop="countryCode" :rules="{ required: true, message: '请输入国家代码',trigger: 'onchange'}" :label-col="{ span: 8 }"  :wrapper-col="{ span: 16 }">
              <a-input v-model="team.countryCode" placeholder="3大写字母如CHN" />
            </a-form-model-item>
            <a-form-model-item :label="`队伍${tIndex+1}得分(用-连接)`" prop="score" :rules="{ required: true, message: '请输入得分(9-8-11-9-9)',trigger: 'onchange' }" :label-col="{ span: 8 }"  :wrapper-col="{ span: 16 }">
              <a-input v-model="team.score" placeholder="如9-8-11-9-9" />
            </a-form-model-item>
          </div>
          <div v-for="(player, pIndex) in team.players" :key="pIndex" class="player-info">
            <a-form-model-item :label="`球员${tIndex+1}${pIndex+1} 英文名`" prop="name" :rules="{ required: true, message: '请输入球员的英文名',trigger: 'onchange' }" :label-col="{ span: 8 }"  :wrapper-col="{ span: 16 }">
              <a-input v-model="player.name" placeholder="输入球员的英文名" />
            </a-form-model-item>
            <a-form-model-item :label="`球员${tIndex+1}${pIndex+1} WTT_Id`" prop="WTTId" :rules="{  required: true, message: '请输入球员的英文名',trigger: 'onchange'  }" :label-col="{ span: 8 }"  :wrapper-col="{ span: 16 }">
              <a-input v-model="player.WTTId" placeholder="必须是6位数字" />
            </a-form-model-item>
          </div>
        </div>
      </div>
    </div>
    <a-button @click="addSubMatch">添加子比赛</a-button>
    <a-button type="primary" @click="submitForm">提交</a-button>
  </a-form-model>
</template>

<script>
import {AddSubEvent, getTeamMatchesAll} from "@/api";
import utils from "@/utils/cardIcon";
import {MatchDescription} from "@/utils/common";
import {message} from "ant-design-vue";

export default {
  data() {
    return {
      form: {
        matchId: '',
        country: '',
        city: '',
        subMatches: [
          {
            category: '',
            level: '',
            date: '',
            isDoubles: false,
            totalScore: '',
            subMatchIndex: '',
            teams: [
              {
                countryCode: '',
                players: [
                  {
                    name: '',
                    WTTId: '',
                  },
                ],
                score: '',
              },
              {
                countryCode: '',
                players: [
                  {
                    name: '',
                    WTTId: '',
                  },
                ],
                score: '',
              },
            ],
            isValid:false
          },
        ],
      },
      matches: ['比赛1', '比赛2', '比赛3'], // 这里可以替换为你的比赛名字列表
      categories: ["Men's Singles", "Women's Singles", "Men's Doubles", "Women's Doubles", "Mixed Doubles",
        "U19 Boys Singles", "U17 Boys Singles", "U15 Boys Singles", "U13 Boys Singles", "U11 Boys Singles",
        "U19 Girls Singles", "U17 Girls Singles", "U15 Girls Singles", "U13 Girls Singles", "U11 Girls Singles",
        "U19 Boys Doubles", "U17 Boys Doubles", "U15 Boys Doubles", "U13 Boys Doubles", "U11 Boys Doubles",
        "U19 Girls Doubles", "U17 Girls Doubles", "U15 Girls Doubles", "U13 Girls Doubles", "U11 Girls Doubles",
        "U19 Mixed Doubles", "U17 Mixed Doubles", "U15 Mixed Doubles", "U13 Mixed Doubles", "U11 Mixed Doubles",
        "U19 Boys Teams", "U17 Boys Teams", "U15 Boys Teams", "U13 Boys Teams", "U11 Boys Teams",
        "U19 Girls Team", "U17 Girls Team", "U15 Girls Team", "U13 Girls Team", "U11 Girls Team"], // 这里可以替换为你的子赛事类别列表
      levels: MatchDescription, // 这里可以替换为你的比赛等级列表
      specialMatchList:[],
      targetMatch: null
    };
  },
  mounted() {
    this.getMatchListAll().then((allMatch) => {
      this.$store.commit('setMatchListAll', allMatch);
      for(let i=0;i<this.$store.state.specialMatch.length;i++){
        this.specialMatchList.push(this.computeFullMatchInfo(this.$store.state.specialMatch[i],allMatch))
      }
    })
  },
  methods: {
    computeFullMatchInfo(match_id,allMatch){
      for(let i=0;i<allMatch.length;i++){
        if(allMatch[i].match_id === match_id){
          return allMatch[i]
        }
      }
      return null
    },
    checkSubMatchValid(subMatch) {
      this.$refs.formModel.validateField(Object.keys(subMatch)).then(() => {
        subMatch.isValid = true;
      }).catch(() => {
        subMatch.isValid = false;
      });
    },
    async getMatchListAll() {
      const response = await getTeamMatchesAll()
      if (response.status === 200) {
        return response.data.matches.sort(utils.compareFnDate)
      }
    },
    addSubMatch() {
      this.form.subMatches.push({
        category: '',
        level: '',
        date: '',
        isDoubles: false,
        subMatchIndex: '',
        teams: [
          {
            countryCode: '',
            players: [
              {
                name: '',
                WTTId: '',
              },
            ],
            score: '',
          },
          {
            countryCode: '',
            players: [
              {
                name: '',
                WTTId: '',
              },
            ],
            score: '',
          },
        ],
      });
    },
    removeSubMatch(index) {
      this.form.subMatches.splice(index, 1);
    },
    calculateScore(score1, score2) {
      const scores1 = score1.split('-').map(Number);
      const scores2 = score2.split('-').map(Number);

      let totalScore1 = 0;
      let totalScore2 = 0;

      for (let i = 0; i < scores1.length; i++) {
        if (scores1[i] > scores2[i]) {
          totalScore1++;
        } else if (scores1[i] < scores2[i]) {
          totalScore2++;
        }
      }

      return `${totalScore1}-${totalScore2}`;
    },
    compute_score(score1, score2) {
      const scores1 = score1.split('-');
      const scores2 = score2.split('-');

      let result = [];
      if(scores1.length!==scores2.length){
        message.error('分数个数不相等')
      }
      if(scores1.length<5){
        let score1_len = scores1.length
        for (let j =0;j<(5-score1_len);j++){
          scores1.push('0')
          scores2.push('0')
        }
      }
      for (let i = 0; i < scores1.length; i++) {
        result.push(`${scores1[i]}-${scores2[i]}`);
      }

      return result.join(',');
    },
    formatDate(date) {
      const d = new Date(date);
      const month = `${d.getMonth() + 1}`.padStart(2, '0');
      const day = `${d.getDate()}`.padStart(2, '0');
      return `${month}/${day}/${d.getFullYear()} 00:00:00`;
    },
    full_score(score_list_str){
      const scores = score_list_str.split('-');
      if(scores.length<5){
        let score1_len = scores.length
        for (let j =0;j<(5-score1_len);j++){
          scores.push('0')
        }
      }
      return scores.join(',')
    },
    handleSubmit() {
      const formData = JSON.parse(JSON.stringify(this.form));
      formData.subMatches.forEach(subMatch => {
        subMatch.date = this.formatDate(subMatch.date);
        subMatch.totalScore = this.calculateScore(subMatch.teams[0].score,subMatch.teams[1].score);
      });

      let options = {
        "match_id": formData.matchId,
        "country_en":formData.country,
        "city_en":formData.city,
        "submit_list":formData.subMatches.map(subMatch=>{
          return{
            "subType":subMatch.category,
            "double":subMatch.isDoubles,
            "subEventDescription":subMatch.category+" - "+subMatch.level+" - Match "+subMatch.subMatchIndex,
            "competitors_a_org":subMatch.teams[0].countryCode,
            "competitors_b_org": subMatch.teams[1].countryCode,
            "competitors_a_scores":this.full_score(subMatch.teams[0].score),
            "competitors_b_scores": this.full_score(subMatch.teams[1].score),
            "competitors_a_players_0_id":subMatch.teams[0].players[0].WTTId,
            "competitors_a_players_1_id":subMatch.isDoubles?subMatch.teams[0].players[1].WTTId:'',
            "competitors_b_players_0_id": subMatch.teams[1].players[0].WTTId,
            "competitors_b_players_1_id": subMatch.isDoubles?subMatch.teams[1].players[0].WTTId:'',
            "competitors_a_players_0_name": subMatch.teams[0].players[0].name,
            "competitors_a_players_1_name": subMatch.isDoubles?subMatch.teams[0].players[1].name:'',
            "competitors_b_players_0_name": subMatch.teams[1].players[0].name,
            "competitors_b_players_1_name": subMatch.isDoubles?subMatch.teams[1].players[1].name:'',
            "resultsGameScores":this.compute_score(subMatch.teams[0].score,subMatch.teams[1].score),
            "resultOverallScores":subMatch.totalScore,
            "subEventDate":subMatch.date
          }
        })
      }
      this.PostAddSubEvent(options)
    },
    async PostAddSubEvent(options){
      const response = await AddSubEvent({data:options})
      if (response.status === 200) {
        message.success(response.data.message)
      }else{
        message.error(response.data.message)
      }
    },
    submitForm() {
      // 自己validate算了
      this.handleSubmit();
      // this.$refs.formModel.validate(valid => {
      //   if (valid) {
      //     this.handleSubmit();
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
  },
  watch: {
    'form.subMatches': {
      handler(newVal) {
        newVal.forEach(subMatch => {
          if (subMatch.isDoubles) {
            subMatch.teams.forEach(team => {
              if (team.players.length === 1) {
                team.players.push({
                  name: '',
                  WTTId: '',
                });
              }
            });
          } else {
            subMatch.teams.forEach(team => {
              if (team.players.length === 2) {
                team.players.pop();
              }
            });
          }
          // this.checkSubMatchValid(subMatch)
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.match-form {
  max-width: 1920px;
  margin: 10px 10px;
}
.comp-name-style{
  //width: 900px !important;
}

.match-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.match-header > .ant-form-item {
  flex: 1;
  margin-right: 5px;
}

.sub-match {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.sub-match-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-right: 10px;
}

.sub-match-info {
  flex: 1;
  margin-right: 10px;
}

.sub-match-info > .ant-form-item {
  margin-bottom: 10px;
}

.sub-match-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.sub-match-row > .ant-form-item {
  flex: 1;
  margin-right: 10px;
}

.teams-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.team-info {
  flex: 1;
  margin-bottom: 10px;
}

.team-info > .ant-form-item {
  margin-bottom: 10px;
}

.team-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.team-row > .ant-form-item {
  flex: 1;
  margin-right: 10px;
}

.player-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.player-info > .ant-form-item {
  flex: 1;
  margin-right: 10px;
}
.valid-sub-match {
  border: 1px solid green;
}
/deep/ .ant-form-item {
  margin-bottom: 5px !important;
}

/deep/ .ant-form-item-control-input-content {
  display: flex !important;
  align-items: center !important;
}

/deep/ .ant-input {
  max-width: 200px !important;
}

/deep/ .ant-select {
  max-width: 200px !important;
}

/deep/ .ant-date-picker {
  max-width: 200px !important;
}

.ant-btn-dashed {
  color: #595959;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}
</style>
